import Link from 'next/link';

import { Folder } from '@/types/cit-public-api';

import { getFolderLink } from '@/lib/navigationUtils';

interface FolderSidebarProps {
  accountId: string;
  folders: Folder[];
  selectedFolderId?: string;
  prefix?: string;
}

export default function FolderSidebar({
  accountId,
  folders,
  selectedFolderId,
  prefix
}: FolderSidebarProps) {
  return (
    <div
      key={accountId}
      className={`h-full bg-white px-1 overflow-y-auto ${
        prefix === 'iframe' ? 'border-r border-gray-200' : ''
      }`}
    >
      <Link
        href={getFolderLink(accountId, undefined, prefix)}
        className={`block px-4 py-2 mb-2 rounded-md ${
          !selectedFolderId ? 'bg-blue-100 text-blue-700' : 'hover:bg-gray-100'
        }`}
        prefetch={false}
      >
        ALL
      </Link>

      {folders.map((folder: Folder) => (
        <Link
          key={folder.id}
          href={getFolderLink(accountId, folder.slug || folder.id, prefix)}
          className={`block px-4 py-2 mb-2 rounded-md ${
            selectedFolderId === folder.slug || selectedFolderId === folder.id
              ? 'bg-blue-100 text-blue-700'
              : 'hover:bg-gray-100'
          }`}
          prefetch={false}
        >
          {folder.name}
        </Link>
      ))}
    </div>
  );
}
